import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import i18next from 'i18next';
import { Text } from '@famly/mf_data-display_text';
import { Stack } from '@famly/mf_layout_stack';
import { fetchChild } from 'signin-app/child/actions';
import Header from 'signin-app/components/header';
import { PinHeader } from 'signin-app/child/pin-header';
import { PageBodyContainer } from 'signin-app/components/action-buttons';
import * as LoginSelectors from 'signin-app/login/selectors';
import { useWhitelabelConfiguration } from 'signin-app/whitelabel/use-whitelabel-configuration';
import * as ChildSelectors from 'signin-app/child/selectors';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { PageContainer } from 'signin-app/components/containers';
import { PersonImage } from 'signin-app/components/person-image';
import { Spinner } from '@famly/mf_feedback_spinner';
import * as Selectors from './selectors';
import { RoomSwitcher } from './room-switcher';
import { CheckOutDetails } from './check-out-details';
import { CheckOutChildProvider, useCheckOutChild } from './check-out-child-context';
const HeaderChildDetails = () => {
    const { child, initials, displayName } = useCheckOutChild();
    return (_jsxs(Stack, { alignItems: "center", gap: 2, children: [_jsx(PersonImage, { size: "sm", image: child.image.small, initials: initials }), _jsx(Text, { variant: "h5", emphasized: true, children: displayName })] }));
};
export const ChildCheckOut = (props) => {
    const { match } = props;
    const [isSwitchingRoomViewVisible, setIsSwitchingRoomViewVisible] = React.useState(false);
    const dispatch = useDispatch();
    const child = useTypedSelector(state => Selectors.getChild(state, props));
    const isFetching = useTypedSelector(ChildSelectors.isFetching);
    const isPinApp = useTypedSelector(LoginSelectors.isPinApp);
    const whitelabelConfiguration = useWhitelabelConfiguration();
    const accessToken = useTypedSelector(LoginSelectors.accessToken);
    const showSwitchRoomView = React.useCallback(() => {
        setIsSwitchingRoomViewVisible(true);
    }, []);
    React.useEffect(() => {
        if (!isPinApp) {
            dispatch(fetchChild.action(accessToken, match.params.childId));
        }
    }, [accessToken, match.params.childId, isPinApp, dispatch]);
    if (isFetching || !child) {
        return (_jsxs(PageContainer, { children: [isPinApp ? _jsx(PinHeader, { whitelabelConfiguration: whitelabelConfiguration }) : _jsx(Header, {}), _jsx(Stack, { justifyContent: "center", width: "100%", children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) })] }));
    }
    return (_jsx(PageContainer, { children: _jsxs(CheckOutChildProvider, { child: child, children: [isPinApp ? (_jsx(PinHeader, { centerElement: _jsx(HeaderChildDetails, {}), whitelabelConfiguration: whitelabelConfiguration })) : (_jsx(Header, { centerElement: _jsx(HeaderChildDetails, {}) })), _jsx(PageBodyContainer, { mt: 16, children: isSwitchingRoomViewVisible ? (_jsx(RoomSwitcher, {})) : (_jsx(CheckOutDetails, { showSwitchRoomView: showSwitchRoomView })) })] }) }));
};
